import { importProvidersFrom, Provider } from '@angular/core';
import { DownloadService, NAVIGATION_ACTION_HANDLERS_TOKEN } from '@polygon/components';
import { AppInitializerCustomService, WildcardService } from '@polygon/core';
import { BREADCRUMBS_ITEMS_STRATEGY, BreadcrumbsFromMenuStrategy } from '@polygon/shell';
import { ngplannerModule } from '@valuekeep/ngplanner';
import { CustomDownloadHandler } from './services/custom-download-handler.service';
import { CustomInitService } from './services/custom-init.service';
import { WildcardCustomService } from './services/wildcard-custom.service';

export const customServices: Provider[] = [];
export const customMainServices = [
	{
		provide: WildcardService,
		useClass: WildcardCustomService
	},
	{
		provide: AppInitializerCustomService,
		useClass: CustomInitService
	},
	importProvidersFrom(ngplannerModule),
	{
		provide: BREADCRUMBS_ITEMS_STRATEGY,
		useClass: BreadcrumbsFromMenuStrategy
	},
	DownloadService,
	{
		provide: NAVIGATION_ACTION_HANDLERS_TOKEN,
		useClass: CustomDownloadHandler,
		multi: true
	}
];
